import { TableStateStore, InitialValues } from "@/utils/TableStateStore";
import { useLocalObservable } from "mobx-react-lite";

export const useTableStateStore = (values: InitialValues) => {
	return useLocalObservable(() => new TableStateStore(values));
};
